import React from 'react'

function Services({service}) {
  
  return (
    <div className=' flex flex-col text-center items-center justify-center mx-4 p-4 '>
      <div className="front">
        <div className="relative rounded-full mx-auto h-60 w-60">
          <img src={service.icon} alt="img" className='rounded-full z-1 absolute'/>
        </div>
        <h1 className="mt-4 text-lpGray text-lg md:text-xl font-bold h-12">{service.title}</h1>
      </div>
    </div>
  )
}

export default Services;